module.exports = __webpack_public_path__ + "img/CBWestDeceased52122.809c9944.jpg";